import { init as initMainCart } from "../sections/main-cart";

export function init() {
  const mainCartSection = document.querySelector(".shopify-section.main-cart");
  if (mainCartSection instanceof HTMLElement) {
    initMainCart(mainCartSection);
  }
}
